<div class="tables-container table-border">
    <div class="tables-row">
        <div class="table-wrapper">
            <h2>Current {{ field.label }} </h2>
            <div class="header-container">
                <h4>Items to be added upon form submission.</h4>
                <div *ngIf="entityType === 'item-sets'" class="generate-set-container">
                    <app-item-set-generator-popup (itemsGenerated)="handleItemsGenerated($event)"></app-item-set-generator-popup>
                  </div>
            </div>
            
            <div class="custom-toolbar">
                <div class="left-buttons">
                    <button type="button" pButton label="Remove Selected" icon="pi pi-trash" 
                            class="p-button-danger p-button-sm" (click)="deleteSelectedItems()" 
                            [disabled]="!selectedItems.length">
                    </button>
                </div>
                
                <div class="center-info">
                    <span class="total-count">Total items: {{ filteredRowData.length }}</span>
                </div>
                
                <div class="right-controls">
                    <!-- Full Edit Mode Toggle (like main ag-grid-table) -->
                    <div style="display: flex; align-items: center;" class="p-mr-2">
                        <i class="pi pi-eye" [style]="{
                            'font-size': '1em',
                            color: isEditingEnabled ? '' : 'var(--primary-color)'
                          }"></i>
                        <p-inputSwitch [(ngModel)]="isEditingEnabled" [disabled]="activeRowEdit" class="p-mx-2"
                          (onChange)="toggleLeftTableEditing()"></p-inputSwitch>
                        <i class="pi pi-pencil" [style]="{
                            'font-size': '1em',
                            color: isEditingEnabled ? 'var(--primary-color)' : ''
                          }"></i>
                    </div>
                    <div *ngIf="activeRowEdit" class="p-mr-2" style="font-size: 0.75rem; color: var(--text-color-secondary);">
                        <strong>Row Editing Active</strong>
                    </div>
                    
                    <!-- Standard Save Changes Button (like ag-grid-table) -->
                    <p-button 
                        class="p-button-sm p-mr-2" 
                        *ngIf="isEditingEnabled" 
                        label="Save Changes" 
                        (click)="submitFullEdit()">
                    </p-button>
                    
                    <!-- Columns Button -->
                    <p-button 
                        label="Columns" 
                        icon="fa-solid fa-table-columns" 
                        class="p-mr-2" 
                        [styleClass]="isColumnsPanelVisible ? 'p-button-sm p-button-outlined' : 'p-button-sm'"
                        (click)="toggleColumnsPanel()">
                    </p-button>
                    
                    <p-button 
                        label="Clear Sorting" 
                        [badge]="sortCounter" 
                        icon="pi pi-sort-alt-slash" 
                        class="p-mr-2" 
                        styleClass="p-button-sm p-button-outlined"
                        (click)="clearLeftTableSorting()">
                    </p-button>
                    
                    <p-button 
                        label="Clear Filters" 
                        [badge]="filterCounter" 
                        icon="pi pi-filter-slash" 
                        class="p-mr-2" 
                        styleClass="p-button-sm p-button-outlined"
                        (click)="clearLeftTableFilters()">
                    </p-button>
                </div>
            </div>

            <ag-grid-angular
                *ngIf="leftTableColumnDefs.length > 0"
                #leftGrid
                [class]="gridTheme"
                [columnDefs]="leftTableColumnDefs"
                [columnTypes]="columnTypes"
                [defaultColDef]="leftDefaultColDef"
                [rowData]="filteredRowData"
                [rowSelection]="'multiple'"
                [suppressRowClickSelection]="true"
                [rowModelType]="'clientSide'"
                [pagination]="true"
                [paginationPageSize]="50"
                [alwaysMultiSort]="true"
                [suppressContextMenu]="true"
                [ensureDomOrder]="true"
                [enableCellTextSelection]="true"
                [enableSorting]="true"
                [enableFilter]="true"
                [floatingFilter]="true"
                [animateRows]="true"
                [editable]="true"
                [singleClickEdit]="true"
                [getRowClass]="getRowClass"
                [sideBar]="leftGridSideBar"
                [style.height]="getLeftGridHeight()"
                [style.width]="'100%'"
                (gridReady)="onLeftGridReady($event)"
                (selectionChanged)="onLeftGridSelectionChanged($event)"
                (cellValueChanged)="onCellValueChanged($event)"
                (filterChanged)="onLeftTableFilterChanged()"
                (sortChanged)="onLeftTableSortChanged()"
            >
            </ag-grid-angular>

            
            <!-- Environment section moved to global form section -->
        </div>
        <div class="table-wrapper">
            <h2>Add {{ field.label }}</h2>
            <h4>Select items to add to the list.</h4>
            <app-ag-grid-table
                *ngIf="columnSelection"
                [entity]="entity"
                [columnDefs]="columnDefs"
                [bulkUpdateColDefs]="bulkUpdateColDefs"
                [autopopulateSelect]="autopopulateSelect"
                [columnSelection]="columnSelection"
                [buildParams]="buildParams"
                [tableParams]="rightTableParams"
                [isTableInput]="isTableInput"
                [tableInputParams]="tableInputParams"
                [itemsRef]="this.record[this.field.key]"
                (selectionChange)="handleSelectionChange($event)"
            >
            </app-ag-grid-table>
        </div>
    </div>

</div>
<p-toast></p-toast>
